<script>
    export let data

    import { Link } from 'svelte-navigator'
    import { getURL } from '../../utils/functions'

    const title = data.title
    const anchor = data.anchor
    const items = data.item
</script>

<div class="section section-projects fp-auto-height-responsive bg-primary" data-section={anchor}>

    <section class="content clearfix">

        <div class="content-centered c-columns">
            <div class="c-title">
                <h2>{title}</h2>
            </div>

            <div class="wrapper clip-overflow anim">

                <div class="gallery-wrapper">
                    <div class="items-tile">
                        <ul class="c-item-list row small-up-1 medium-up-2 large-up-3">
                            {#if items}
                            {#each items as item}
                            <li class="column">
                                {#if item.file}
                                <a href={getURL(item.file.url)} target="_blank" class="tile-wrapper" download>
                                    <div class="item-img portrait">
                                        <div class="img bg-img" data-image-src={getURL(item.thumbnail.url)}></div>
                                    </div>
                                    <div class="item-desc color-overlay">
                                        <span class="anim-wrapper">
                                            <h3 class="title text-shadow">{item.name}</h3>
                                        </span>
                                        
                                        <h4 class="text-shadow">{item.description}</h4>
                                    </div>
                                </a>
                                {:else if item.link}
                                    {#if !item.internal_link}
                                        <a href={item.link} target="_blank" class="tile-wrapper">
                                            <div class="item-img portrait">
                                                <div class="img bg-img" data-image-src={getURL(item.thumbnail.url)}></div>
                                            </div>
                                            <div class="item-desc color-overlay">
                                                <span class="anim-wrapper">
                                                    <h3 class="title text-shadow">{item.name}</h3>
                                                </span>
                                                
                                                <h4 class="text-shadow">{item.description}</h4>
                                            </div>
                                        </a>
                                    {:else if item.internal_link}
                                        <Link to={item.link} class="tile-wrapper">
                                            <div class="item-img">
                                                <div class="img bg-img" data-image-src={getURL(item.thumbnail.url)}></div>
                                            </div>
                                            <div class="item-desc color-overlay">
                                                <span class="anim-wrapper">
                                                    <h3 class="title text-shadow">{item.name}</h3>
                                                </span>
                                                
                                                <h4 class="text-shadow">{item.description}</h4>
                                            </div>
                                        </Link>
                                    {/if}
                                {/if}
                            </li>
                            {/each}
                            {/if}
                        </ul>
                    </div>
                </div>
                
            </div>
        </div>

    </section>

</div>